export const staticTexts = lang => {
  if (lang === "en") {
    return {
      NUMBER_ARRAY: ["0", "1", "2", "3", "4", "5", "6", "7", "8", "9"],
      login: "Login",
      register: "Register",
      loginorRegister: "Login/Register for:",
      saveToRead: "Save to read on any device",
      commentAndReply: "Comment and reply",
      breakingNewsAlerts: "Breaking news alert",
      profile: "Profile",
      localNews: "Local news",
      search: "Search",
      subscribeNewsletters: "Subscribe newsletter",
      "e-mail": "e-mail",
      downloadMobileApps: "Download mobile apps",
      newsYouCommented: "News you commented",
      youDidntSaveComment: "You didn’t comment yet",
      newsYouSaved: "News you saved",
      youDidntSaveNews: "You didn’t save any news yet",
      editProfile: "Edit Profile",
      editProfileBtnText: "EDIT PROFILE",
      saveToReadLater: "Save to read later",
      alsoRead: "Also Read",
      searchBoxText: "Search",
      language: "English",
      defaultEditor: "Editor and Publisher: Matiur Rahman",
      edition: "Edition",
      loadMore: "Load More",
      more: "Load More",
      relatedStories: "More News",
      morePhotoStories: "More",
      readMore: "Read More",
      advertising: "Advertisement",
      publishedAt: "Published",
      updatedAt: "Updated",
      section: "Section",
      district: "District",
      upazila: "Upazila",
      tag: "Topic",
      author: "Author",
      notifications: "Notifications",
      advanceSearch: "Search",
      sekasana: "Section",
      news: "News",
      newToOld: "Sort by",
      date: "Date Range",
      advanceSearchBox: "Search",
      resultsObtained: "The Results Obtained",
      breakingNews: "Breaking News",
      download: "Download",
      storyTypes: "Story Types",
      fromTheDate: "Start date",
      upToNow: "End Date",
      shareOnFacebook: "Share on Facebook",
      pleaseEmail: "Email",
      copyLink: "Copy link",
      shareOnLinkedIn: "Share on LinkedIn",
      shareOnTwitter: "Share on Twitter",
      print: "Print",
      shareOnWatsapp: "Share on Watsapp",
      shareOnInsta: "Share on Instagram",
      share: "Share",
      noResultsFound: "No Results Found",
      noResultsBreif:
        "The object you are looking for could not be found. This topic is probably not related to Prothom Alo or you are searching incorrectly. Please be sure about your search topic.",
      cover: "Home",
      nextVideo: "Next Video",
      readComments: "Read Comments",
      yourCommentsWillBeSeenHere: "Your comments will show here.",
      myAccout: "My Account",
      myProfile: "My Profile",
      activities: "Activities",
      myComments: "My Comments",
      mySavedNews: "My Saved News",
      recommenedNews: "Recommended News",
      email: "Email",
      country: "Country",
      birthday: "Birthday",
      contact: "Contact",
      changePassword: "Change Password",
      emailAddress: "E-mail Address",
      personalInformation: "PERSONAL INFORMATION",
      gender: "Gender",
      name: "Name",
      countryOrRegion: "Country / Region",
      contactNumber: "Contact Number ",
      save: "SAVE",
      invalidUsernameOrPassword: "Invalid username / password",
      logOut: "Log Out",
      emailVerification: "E-mail Verification",
      createAnAccount: "Create an account",
      otpconfirmation: "OTP Confirmation",
      enterOtp: "Enter OTP",
      OneAccountAll: "One account. All of Prothom Alo",
      workingForYou: "working for you",
      savedPageTitle: "Saved Items",
      savedPageSubTitle: "Your saved item(s) have been added to your reading list. You can access on any device",
      notVerifiedText: "Email account not verified",
      clickToVerifyText: "Click here to verify"
    };
  } else {
    return {
      NUMBER_ARRAY: ["০", "১", "২", "৩", "৪", "৫", "৬", "৭", "৮", "৯"],
      login: "লগইন",
      register: "রেজিস্টার",
      loginorRegister: "লগইন / রেজিস্টার পাঠক পাবেন:",
      saveToRead: "খবর সংরক্ষণ করে যেকোনো সময় যেকোনো ডিভাইস থেকে পড়তে পারবেন",
      commentAndReply: "খবরে মন্তব্য এবং অন্যান্য পাঠকের মন্তব্যের জবাব দিতে পারবেন",
      breakingNewsAlerts: "ব্রেকিং নিউজ অ্যালার্ট চালু করে তাৎক্ষণিক খবর সম্পর্কে জানতে পারবেন",
      profile: "প্রোফাইল",
      localNews: "আমার এলাকার খবর",
      search: "খুঁজুন",
      subscribeNewsletters: "প্রথম আলো নিউজ লেটারের গ্রাহক হোন",
      "e-mail": "ই-মেইল",
      downloadMobileApps: "মোবাইল অ্যাপস ডাউনলোড করুন",
      newsYouCommented: "আপনার মন্তব্য করা খবর",
      youDidntSaveComment: "আপনি কোনো খবরে মন্তব্য করেননি",
      newsYouSaved: "আপনার সংরক্ষণ করা খবর",
      youDidntSaveNews: "এডিট প্রোফাইল",
      editProfile: "এডিট প্রোফাইল",
      editProfileBtnText: "এডিট প্রোফাইল",
      saveToReadLater: "পরবর্তীতে পড়ার জন্য সংরক্ষণ",
      alsoRead: "আরও পড়ুন",
      searchBoxText: "কি খুঁজতে চান?",
      language: "বাংলা",
      defaultEditor: "সম্পাদক ও প্রকাশক: মতিউর রহমান",
      edition: "সংস্করণ",
      loadMore: "আরও খবর",
      more: "আরও",
      relatedStories: "এ সম্পর্কিত আরও খবর",
      morePhotoStories: "আরও ছবির গল্প",
      readMore: "আরও পড়ুন",
      advertising: "বিজ্ঞাপন",
      publishedAt: "প্রকাশ",
      updatedAt: "আপডেট",
      section: "বিভাগ",
      district: "জেলা",
      upazila: "উপজেলা",
      tag: "ট্যাগ",
      author: "লেখক",
      notifications: "নোটিফিকেশন",
      advanceSearch: "অনুসন্ধান",
      sekasana: "সেকশন",
      news: "খবর",
      newToOld: "নতুন থেকে পুরোনো",
      date: "তারিখ",
      advanceSearchBox: "অনুসন্ধান করুন",
      resultsObtained: "প্রাপ্ত ফলাফল",
      breakingNews: "এইমাত্র পাওয়া",
      download: "ডাউনলোড",
      storyTypes: "খবর",
      fromTheDate: "তারিখ হইতে",
      upToNow: "এখন পর্যন্ত",
      shareOnFacebook: "ফেসবুকে শেয়ার করুন",
      pleaseEmail: "ইমেইল করুন",
      copyLink: "খবরের লিংক কপি করুন",
      shareOnLinkedIn: "লিংকডইনে শেয়ার করুন",
      shareOnTwitter: "টুইটারে শেয়ার করুন",
      print: "প্রিন্ট করুন",
      shareOnWatsapp: "ওয়াটসঅ্যাপে ভাগ করুন",
      shareOnInsta: "ইনস্টাগ্রামে শেয়ার করুন",
      share: "শেয়ার",
      noResultsFound: "কোন ফলাফল পাওয়া যায়নি",
      noResultsBreif:
        "আপনি যে বিষয়টি অনুসন্ধান করছেন তা খুজে পাওয়া যায়নি। বিষয়টি সম্ভবত প্রথম আলোর সাথে সংশ্লিষ্ট নয় অথবা আপনি ভুলভাবে অনুসন্ধান করছেন। অনুগ্রহ করে আপনার অনুসন্ধান বিষয়টি সম্বন্ধে নিশ্চিত হোন।",
      cover: "প্রচ্ছদ",
      nextVideo: "পরবর্তী ভিডিও",
      readComments: "মন্তব্য পড়ুন",
      yourCommentsWillBeSeenHere: "আপনার করা মন্তব্য এখানে পাওয়া যাবে",
      myAccout: "আমার অ্যাকাউন্ট",
      myProfile: "আমার প্রোফাইল",
      activities: "ক্রিয়াকলাপ",
      myComments: "আমার মন্তব্য",
      mySavedNews: "আমার সংরক্ষিত সংবাদ",
      recommenedNews: "প্রস্তাবিত সংবাদ",
      email: "ই-মেইল",
      country: "দেশ",
      birthday: "জন্মদিন",
      contact: "যোগাযোগ",
      changePassword: "পাসওয়ার্ড পরিবর্তন করুন",
      emailAddress: "ই-মেইল ঠিকানা",
      personalInformation: "ব্যক্তিগত তথ্য",
      gender: "লিঙ্গ",
      name: "নাম",
      countryOrRegion: "দেশ / অঞ্চল",
      contactNumber: "যোগাযোগের নম্বর",
      save: "সংরক্ষণ",
      invalidUsernameOrPassword: "অবৈধ ব্যবহারকারীর নাম / পাসওয়ার্ড",
      logOut: "লগ আউট",
      emailVerification: "ইমেল যাচাই",
      createAnAccount: "একটি অ্যাকাউন্ট তৈরি করুন",
      otpconfirmation: "ওটিপি নিশ্চিতকরণ",
      enterOtp: "ওটিপি প্রবেশ করান",
      OneAccountAll: "এক হিসাব প্রথম আলো সব",
      workingForYou: "তোমার জন্য কাজ করছি",
      savedPageTitle: "আপনার সংরক্ষিত খবর",
      savedPageSubTitle:
        "আপনার সংরক্ষণ করা গল্পগুলি আপনার পঠন তালিকায় যুক্ত করা হয়েছে। যে কোনও ডিভাইসে অ্যাক্সেস করুন।",
      notVerifiedText: "ইমেল অ্যাকাউন্ট যাচাই করা হয়নি.",
      clickToVerifyText: "যাচাই করতে এখানে ক্লিক করুন"
    };
  }
};
